import * as React from 'react';
import {
  PickerOptions,
  PickerResponse,
  PickerInstance,
} from 'filestack-js/build/main/lib/picker';
import { useHistory } from 'react-router-dom';

import { isValidUrl } from 'utils';
import fileStackClient from '../../filestack';

type AttachmentForm = {
  url: string;
  filename: string;
};

type OfferAttachmentButtonProps = {
  attachmentForm: AttachmentForm;
  onAttachmentUpdate: (attachment: AttachmentForm | null) => void;
  required?: boolean;
};

const OfferAttachmentButton: React.FunctionComponent<
  OfferAttachmentButtonProps
> = ({ attachmentForm, onAttachmentUpdate, required }) => {
  const history = useHistory();
  const [pickerInstance, setPickerInstance] =
    React.useState<PickerInstance | null>(null);

  React.useEffect(() => () => {
      if (pickerInstance && typeof pickerInstance.close === 'function')
        pickerInstance.close();
    }, [history, pickerInstance]);

  const openFileUpload = () => {
    const processResult = (result: PickerResponse) => {
      if (result.filesUploaded?.length) {
        const attachment = result.filesUploaded[0];
        onAttachmentUpdate(attachment);
      }
    };

    const opts: PickerOptions = {
      maxFiles: 1,
      onFileSelected: file => {
        if (file.source === 'url' && !isValidUrl(file.originalPath))
          throw new Error('Invalid URL format. Please try again.');
      },
      onUploadDone: result => processResult(result),
    };

    const picker = fileStackClient.picker(opts);
    setPickerInstance(picker);
    picker.open();
  };

  return (
    <>
      <button className="btn btn-primary" onClick={openFileUpload}>
        ATTACH OFFER DOC
      </button>
      {attachmentForm?.url ? (
        <div>
          <h4>Attachments</h4>
          <a
            href={attachmentForm.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {attachmentForm.filename}
          </a>
          <i
            className="pe-7s-trash fat pull-right"
            onClick={() => onAttachmentUpdate(null)}
          ></i>
        </div>
      ) : (
        <>
          <h4>No form attached.</h4>
          {required && <label className="error">Offer Doc is required.</label>}
        </>
      )}
    </>
  );
};

export default OfferAttachmentButton;
